<template>
  <div id="countyTotal">
    <div
      class="countytotal-content"
      :style="contentStyle"
      v-loading="reportloading"
    >
      <el-row :gutter="20">
        <el-col :span="10" style="text-align: left">
          <el-button
            @click="exportToExcel"
            v-has="'export-perm'"
            size="small"
            type="primary"
            >导出<i
              class="fa fa-arrow-circle-o-down"
              style="margin-left: 6px"
            ></i></el-button>
          <div style="display: inline-block;margin-left: 6px">
            <i
              class="fa fa-bar-chart"
              aria-hidden="true"
              style="color: #409EFF;"
            ></i>
            <el-button @click="toggleTable" type="text" size="small">切换至图表模式</el-button>
          </div>
        </el-col>
        <el-col :span="14" style="float: right">
          <el-form
            class="searchForm"
            ref="searchForm"
            :model="searchForm"
            size="mini"
            inline
          >
            <SearchForm
                v-model="searchForm"
              :searchList="searchList"
              @seacrhMethod="seacrhMethod"
              :currentMenuId="currentMenuId"
            ></SearchForm>
          </el-form>
        </el-col>
      </el-row>

      <div style="display: flex; ">
        <deptChoosed
          v-model="checkedDept"
          :heightAll="heightAll - 88"
          :currentMenuId="currentMenuId"
        ></deptChoosed>

        <el-table
          class="table"
          :height="heightAll - 70"
          v-loading="loading"
          id="table-content"
          :data="tableData"
          stripe
          show-summary
          sum-text="总计"
          :summary-method="summaryList"
          size="medium"
          style="width: 100%;"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            prop="deptName"
            align="center"
            label="执法机构"
          >
          </el-table-column>
          <el-table-column
            prop="userCNum"
            align="center"
            label="用户总数"
            width="90px"
          >
          </el-table-column>
          <el-table-column
            prop="onInspectNum"
            align="center"
            label="正在进行中任务数量"
            width="170px"
          >
          </el-table-column>
          <el-table-column
            prop="overInspectNum"
            align="center"
            label="已完成任务数量"
            width="170px"
          >
          </el-table-column>
          <el-table-column
            prop="allInspectNum"
            align="center"
            label="执法总记录数"
            width="170px"
          >
          </el-table-column>
          <el-table-column align="center" label="完成率" width="170px">
            <template slot-scope="scope">
              {{
                scope.row.allInspectNum == "0"
                  ? 0
                  : (
                      (scope.row.overInspectNum * 100) /
                      scope.row.allInspectNum
                    ).toFixed(2) + "%"
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-footer></el-footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import { mapState } from "vuex";
import { renderTime } from "@/utils/time";
import { deptStatis, exportDeptStatis } from "../../api/module/statistics";
import deptChoosed from "../../components/deptmenu/deptChoosed";
import SearchForm from "@/components/core/SearchForm";

export default {
  name: "CountyTotal",
  components: {
    "el-footer": Footer,
    deptChoosed,
    SearchForm
  },
  computed: {
    ...mapState(["logInfo"])
  },
  props: ["currentMenuId", "heightAll"],
  data() {
    return {
      contentStyle: {
        height: "",
        overflow: "hidden"
      },
      tableData: [],
      tableHeight: 0,
      loading: true,
      times: "",
      beginTime: "",
      endTime: "",
      searchForm: {
        times: "" // 搜索时间
      },
      searchList: {
        times: {
          label: "起止时间",
          itemwidth: "228px",
          type: "datepick",
          data: "",
          btns: [7, 30, 90],
          deflut: 7,
          key: "times",
          value: ""
        }
      },
      reportloading: false,
      checkedDept: []
    };
  },
  created() {
    this.defaultTime();
    this.getTableList();
  },
  methods: {
    toggleTable() {
      this.$emit("toggleTable")
    },
    getTableList() {
      if (this.times != null && this.times.length > 0) {
        this.beginTime = renderTime(this.times[0]);
        this.endTime = renderTime(this.times[1]);
      } else {
        this.beginTime = "";
        this.endTime = "";
      }
      let deptParam = new FormData();
      deptParam.append("currentPage", 1);
      deptParam.append("pageSize", 9999);
      deptParam.append("startTime", this.beginTime);
      deptParam.append("endTime", this.endTime);
      if (this.checkedDept && this.checkedDept.length <= 0) {
        let arr = [];
        arr.push(this.logInfo.deptId);
        this.checkedDept = arr;
      }
      for (let i = 0; i < this.checkedDept.length; i++) {
        deptParam.append("deptIdArr", this.checkedDept[i]);
      }
      deptStatis(
        deptParam,
        res => {
          this.tableData = res.obj.list;
          this.loading = false;
        },
        () => {
          // console.log(res)
        },
        this.currentMenuId
      );
    },
    exportToExcel() {
      if (!this.checkedDept || this.checkedDept.length <= 0) {
        let arr = [];
        arr.push(this.logInfo.deptId);
        this.checkedDept = arr;
      }

      let obj = {
        deptIdArr: this.checkedDept,
        currentPage: 1,
        pageSize: 99999,
        startTime: this.searchForm.times[0]
          ? renderTime(this.searchForm.times[0])
          : "",
        endTime: this.searchForm.times[1]
          ? renderTime(this.searchForm.times[1])
          : ""
      };
      exportDeptStatis(
        obj,
        res => {
          // console.log(res);
          this.reportloading = false;
          const name = renderTime(new Date()).slice(0, 11);
          const title = `部门检查任务统计-${name}.xlsx`;
          if ("msSaveOrOpenBlob" in navigator) {
            // 判断是ie的浏览器，调用ie文件下载的方法
            const blob = new Blob([res.data]);
            window.navigator.msSaveOrOpenBlob(blob, title);
          }
          const blob = new Blob([res.data]);
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = title; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
        },
        () => {},
        this.currentMenuId
      );
      this.reportloading = true;
    },
    summaryList(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            }
            return prev;
          }, 0);
        }
        if (index === columns.length - 1) {
          sums[index] = sums[4]
            ? `${((sums[3] * 100) / sums[4]).toFixed(2)}%`
            : 0;
        }
      });

      return sums;
    },
    seacrhMethod(data) {
      // console.log('查询', data);
      this.searchForm = data;
      this.times = data.times;
      this.getTableList();
    },
    defaultTime() {
      this.searchList.times.value = this.$getRangeStartEnd(
        this.searchList.times.deflut
      );
      this.times = this.$getRangeStartEnd(this.searchList.times.deflut);
      this.searchForm.times = this.$getRangeStartEnd(
        this.searchList.times.deflut
      );
    }
  }
};
</script>

<style scoped>
/*//重置部分样式*/
@import "../../assets/reset.css";
#countyTotal {
  background: white;
  overflow: hidden;
}
#countyTotal > .countytotal-content {
  padding: 10px;
}

/*el-scroll 横向滚动条隐藏*/
#countyTotal >>> .el-scrollbar__wrap {
  overflow-x: hidden !important;
}

/*//滚动条的宽度*/
.countytotal-content >>> .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
/*//滚动条的滑块*/
.countytotal-content >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.5);
  border-radius: 3px;
}
</style>
